<template>
  <div class="ph-compare-main ">
    <el-backtop ></el-backtop>
    <hpheader v-if="showHeader"></hpheader>


    <ph-compare-table :list="compareProductList" :column="attrOptions" @removeCompareProduct="removeCompareProduct"></ph-compare-table>
    <hpfooter></hpfooter>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import hpheader from '@/common/hpheader.vue'
import hpfooter from '@/common/hpfooter.vue'
import positionBar from '@/components/ph-position-bar.vue'
import {session} from "@/storage/storage"
import phCompareTable from "@/components/compare/ph-table.vue"
export default {
  components: {
    positionBar,
    hpfooter,
    hpheader,
    phCompareTable
    // circularProgress,
    // endoButton,
    // videoModal,
  },
  data() {
    return {
      showHeader: true,
      is_mounted: false,
      productc_nav: false,
      videoProgress: 0,
      videoIsPlaying: true,
      contraAngleSliderValue: 0,
      valuid:1,
      positionNav:[
        // {
        //   title:'Home',
        //   path:'/phhome',
        // },
        // {
        //   title:'Product',
        //   path:'/phproduct',
        // },
        {
          title: 'Endo GT Series',
          path: '/ph/special/endo'
        },
      ],
      channel_id:session.get("channel_id") == '' ? 1 : session.get("channel_id"),
      detail: {},
      value: '产品详情',
      hasUserInteraction: false,
      compareProductList: [],
      attrOptions: [],
    };
  },
  computed:{
    ...mapState(['compare']),
  },
  created(){
    this.ress()

  },
  mounted() {
    let _this = this
    this.$nextTick(() => {
      _this.is_mounted = true
      _this.resetAttrOptions()
      _this.initCompareProduct()
      // this.addCompareProduct(192)
      // this.addCompareProduct(229)
    })
  },
  methods: {
    async removeCompareProduct(index){
      let products = this.compare.products
      products.splice(index,1)
      await this.$store.commit('saveCompareProducts', products)
      this.compareProductList = []
      this.initCompareProduct()
    },
    ress(){
      var html = document.documentElement; //获取根元素
      var designWidth = 750; //设计稿宽度
      //html.clientWidth 视口宽度
      html.style.fontSize = html.clientWidth / designWidth * 100 + "px"; //设置字体大小
    },

    handleScroll() {
      let scrollTop = document.documentElement.scrollTop || document.body.scrollTop
      let head_height = this.$refs.head.getHeaderHeight()
      if (scrollTop > head_height) {
        this.productc_nav = true
        this.scroll_height = scrollTop
      } else {
        this.productc_nav = false
      }
      this.$refs.head.scrollTop_change(scrollTop, 'pcquerys')
    },
    async initCompareProduct(){
      // let res = await this.$api.get_compare_product({id})
      // this.compareProductList.push({
      //   ...res.data,
      // })
      this.compare.products.forEach((item) => {
        this.compareProductList.push({
          ...item
        })
      })
      this.handleCompareData()

    },
    handleCompareData(){
      this.resetAttrOptions()
      this.compareProductList.forEach((item) => {
        if (!item.parameter) return;
        // const p = item.parameter.filter((parameter) => {
        //   if(parameter.value != ''){
        //     return parameter
        //   }
        //   if(parameter.is_check == 1){
        //     parameter.value = parameter.is_check
        //     return parameter
        //   }
        //   return  false
        // })
        // item.parameter = p
        item.parameter.forEach((parameter) => {
          if(parameter.attr){
            const exists = this.attrOptions.some(attr => attr.value === parameter.attr.id);
            if (!exists) {
              this.attrOptions.push({
                value: parameter.attr.id,
                label: parameter.attr.name,
                is_center: parameter.attr.is_center,
                sort: parameter.attr.sort
              });
            }
          }
        });
      });
      this.attrOptions.sort((a, b) => a.sort - b.sort);

      this.compareProductList.forEach((item) => {
        if (!item.parameter) item.parameter = [];
        const toAdd = [];
        this.attrOptions.forEach(attr => {
          if (attr.value === -1 || attr.value === -2) return;
          const hasAttr = item.parameter.some(p => p.attr && p.attr.id === attr.value);
          if (!hasAttr) {
            toAdd.push({
              attr: {
                id: attr.value,
                name: attr.label
              },
              value: '',
              is_check: 0,
              is_center: 0,
              attr_id: attr.value
            });
          }
        });
        item.parameter.push(...toAdd);
      });
      this.$forceUpdate()
    },
    resetAttrOptions(){
      this.attrOptions = [
        {
          value: -2,
          label: 'Prodcut Model',
          is_center: 1,
        },
        {
          value: -1,
          label: 'Category',
          is_center: 0,
        },
      ]
    },
  },
  beforeDestroy() {

  }
};
</script>

<style >

</style>
